import React from "react";
// sonner
import { toast } from "sonner";
// @Mui
import { useTheme } from "@mui/material";
//
import ToastContent from "src/components/Toaster/ToastContent";

// ----------------------------------------------------------------------------------------------------------

function useToaster() {
  const theme = useTheme();

  const variants = {
    success: {
      color: theme.palette.success.main,
      icon: "solar:check-circle-broken",
    },
    info: {
      color: theme.palette.info.main,
      icon: "solar:info-circle-broken",
    },
    warning: {
      color: theme.palette.warning.main,
      icon: "solar:shield-warning-broken",
    },
    error: {
      color: theme.palette.error.main,
      icon: "solar:close-circle-broken",
    },
  };

  const triggerToast = (variant, content) => {
    toast(<ToastContent data={{ ...variants[variant], content }} />);
  };

  return {
    triggerToast,
  };
}

export default useToaster;
